module.exports = __webpack_public_path__ + "media/images/favicons/16x16-292809e4056fe73b1bdebf78e1128972.png";